import angular from 'angular';
import 'angular-animate';

export default angular.module('ChModal', [
  'ngAnimate'
]);



// WEBPACK FOOTER //
// ./app.js